export const renderTextWithLink = (text) => {
  if (typeof text !== "string" || !text) return text;

  const urlRegex = /(https?:\/\/[^\s"<>]+)/g;

  return text.replace(urlRegex, (match) => {
    let cleaned = match;
    let trailing = "";

    const openParens = (cleaned.match(/\(/g) || []).length;
    const closeParens = (cleaned.match(/\)/g) || []).length;

    if (closeParens > openParens) {
      const diff = closeParens - openParens;
      trailing = ")".repeat(diff);
      cleaned = cleaned.slice(0, -diff);
    }

    const trailingPunct = cleaned.match(/[.,!?;:]+$/);
    if (trailingPunct) {
      trailing = trailingPunct[0] + trailing;
      cleaned = cleaned.slice(0, -trailingPunct[0].length);
    }

    try {
      const u = new URL(cleaned);

      let display = "";

      if (typeof number !== "number") {
        display = `${u.origin}${u.pathname}`;
      } else {
        display = `${u.origin}${u.pathname}${u.search}${u.hash}`;
      }
      return `<a href="${u}" target="_blank" rel="noopener noreferrer">${display}</a>${trailing}`;
    } catch {
      return match;
    }
  });
};
